import React from 'react';
import { FaClock, FaPause, FaStar, FaBolt } from 'react-icons/fa';
import Button from '../common/Button';

const HUD = ({ score, time, level, combo, onPause }) => {
  return (
    <div className="absolute top-0 left-0 w-full p-4 z-50 pointer-events-none flex flex-col justify-between h-full">
      {/* Top Bar */}
      <div className="flex justify-between items-start pointer-events-auto">
        <div className="flex flex-col gap-2">
          {/* Timer */}
          <div className="bg-accent2 text-white px-4 py-2 rounded-2xl shadow-md flex items-center gap-2 font-bold text-xl min-w-[100px]">
            <FaClock />
            <span>{time}s</span>
          </div>

          {/* Level */}
          <div className="bg-accent3 text-white px-4 py-1 rounded-2xl shadow-md text-sm font-bold">
            Lv. {level}
          </div>
        </div>

        {/* Score */}
        <div className="bg-primary text-white px-6 py-2 rounded-2xl shadow-md flex flex-col items-center min-w-[120px]">
          <span className="text-xs opacity-90 uppercase tracking-wide">Score</span>
          <span className="text-2xl font-bold">{score}</span>
        </div>

        {/* Pause Button */}
        <Button
          onClick={onPause}
          size="sm"
          variant="accent"
          className="rounded-xl aspect-square p-0 w-10 h-10 flex items-center justify-center"
        >
          <FaPause />
        </Button>
      </div>
    </div>
  );
};

export default HUD;